<template>
    <div class="tree">
        <tree-node :node="node" :mode="mode" v-for="(node, index) in data" :key="index" />
    </div>
</template>

<script>
import TreeNode from './TreeNode';

export default {
  components: {
    TreeNode
  },
  props: ['data', 'mode']
};
</script>




// WEBPACK FOOTER //
// src/components/Tree.vue